import React from "react";

const defaultValue = {
  locale: 'id',
  setLocale: () => {} 
}

export default React.createContext(defaultValue);